import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { FormControl, Select, MenuItem } from '@mui/material';
import { useClient } from '../../../../reactQuery/client';
import { useClientBuildings } from '../../../../reactQuery/building';
import { generateAffidavitDocument } from './AffidavitGenerator';

function AffidavitForMailing() {
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [buildings, setBuildings] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch clients data
  const { responseData: clients } = useClient({ pagination: false }, "affidavit-mailing-clients");

  // Fetch buildings data based on selected client
  const { isLoading, responseData, refetch } = useClientBuildings(
    {
      page: 1,
      pageSize: 1,
      clientId: selectedClient,
      pagination: false,
    },
    selectedClient
  );

  useEffect(() => {
    if (selectedClient) {
      refetch();
    }
  }, [selectedClient, refetch]);

  useEffect(() => {
    if (responseData) {
      setBuildings(responseData);
    }
  }, [responseData]);

  const handleClientChange = (event) => {
    const client = event.target.value;
    setSelectedClient(client);
    setSelectedBuilding('');
  };

  const handleBuildingChange = (event) => {
    setSelectedBuilding(event.target.value);
  };

  const handleDownloadAffidavit = async () => {
    if (!selectedClient || !selectedBuilding) return;
    
    setLoading(true);
    try {
      const clientData = clients.find(client => client.client_id === selectedClient);
      const buildingData = buildings.find(building => building.building_id === selectedBuilding);
      
      if (!clientData || !buildingData) {
        console.error("Client or building data not found");
        return;
      }
      
      await generateAffidavitDocument(clientData, buildingData);
    } catch (error) {
      console.error("Error generating affidavit document:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="report-card-content">
      <Typography variant="body2" className="report-description">
        Download a notarizable affidavit certifying that notices for the selected
        property were deposited with the U.S. Postal Service.
      </Typography>
      <Box className="report-action report-action-double">
        {/* Client Selector */}
        <FormControl className="client-select">
          <Select
            value={selectedClient}
            onChange={handleClientChange}
            displayEmpty
            className="select-box"
          >
            <MenuItem value="" disabled>
              <em>Select Client</em>
            </MenuItem>
            {clients && clients.map((client) => (
              <MenuItem key={client.client_id} value={client.client_id}>
                {client.company_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Building Selector */}
        <FormControl className="building-select" disabled={!selectedClient || isLoading}>
          <Select
            value={selectedBuilding}
            onChange={handleBuildingChange}
            displayEmpty
            className="select-box"
          >
            <MenuItem value="" disabled>
              <em>Select Building</em>
            </MenuItem>
            {buildings.map((building) => (
              <MenuItem key={building.building_id} value={building.building_id}>
                {building.address}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Download Button */}
        <Button
          variant="contained"
          className="affidavit-report-btn"
          onClick={handleDownloadAffidavit}
          disabled={!selectedClient || !selectedBuilding || loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadOutlinedIcon />}
         
        >
          {loading ? 'Generating...' : 'Affidavit Report'}
        </Button>
      </Box>
    </Box>
  );
}

export default AffidavitForMailing;